<div class="provider-selector" [class.disabled]="isDisabled" (click)="$event.stopPropagation()">
  <div
    class="trigger"
    [class.disabled]="isDisabled"
    [attr.aria-disabled]="isDisabled"
    (click)="toggleOpen()">
    <div class="label">
      <span class="selected" *ngIf="selected">{{ selected.Name }}</span>
      <span class="placeholder" *ngIf="!selected">{{ placeholder | translate }}</span>
    </div>
    <span class="chevron" aria-hidden="true"></span>
  </div>

  <div class="panel" *ngIf="open">
    <div class="search">
      <span class="icon" aria-hidden="true"></span>
      <input
        type="text"
        [ngModel]="searchTerm"
        (ngModelChange)="onSearchChange($event)"
        [placeholder]="'provider_selector.search' | translate"
      />
      <button
        class="clear"
        *ngIf="searchTerm"
        (click)="clearSearch()"
        type="button"
        [attr.aria-label]="'provider_selector.clear_search' | translate"
        [attr.title]="'provider_selector.clear_search' | translate"
      >&times;</button>
    </div>

    <ul class="list" *ngIf="!loading && !hasError">
      <li
        class="item"
        *ngFor="let provider of filteredProviders"
        [class.active]="selected?.Id === provider.Id"
        (click)="selectProvider(provider)">
        <div class="name">{{ provider.Name }}</div>
      </li>
      <li class="empty" *ngIf="filteredProviders.length === 0">{{ 'provider_selector.no_results' | translate }}</li>
    </ul>

    <div class="state" *ngIf="loading">{{ 'provider_selector.loading' | translate }}</div>
    <div class="state error" *ngIf="!loading && hasError">{{ 'provider_selector.error' | translate }}</div>
  </div>
</div>

